/* eslint-disable prettier/prettier */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { styled } from "styled-components";
import moment from "moment";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import dayjs from "dayjs";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import InputField from "../../components/Layout/InputField";
import Button from "../../components/Layout/Button";
// import DataTable from "../../components/Layout/Table/DataTable";
import TableData from "../../components/Layout/Table/TableData";
// import { Heading } from '../../components/Layout/Typography';
import {
  OuterContainerStyles,
  Title,
  SearchContainer,
  ExistingText,
  SearchContainerTable,
} from "../../components/Layout/Typography";
import Heading from "../../components/Layout/Heading";
import { SERVICES } from "../../components/Layout/Services";
import fetchData from "../../components/Layout/FetchData";
import {
  del,
  post,
  get,
  put,
} from "../../components/Layout/ApiHandler/apihandler";
import EditModal from "../../components/Layout/Modal";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Loader from "../../components/Loader/Loader";
import NoData from "../../components/NoData";
import CycleModal from "./Componenets/Modal";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";
import EditIcon from "../../components/Svg/EditIcon";

const MainContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
  margin: 0 auto;
`;
// const ExistingPayableCity = styled.div`
//     border: 1px solid #D9DEE1;
//     border-radius: 5px;
//     margin-top: 50px;
//     margin-bottom: 50px;
//     padding: 50px;

// `;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
const Text = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #000000;
`;
const TextCity = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

const DEFAULT_PAGE_SIZE = 10;

function ContributionCycleDetails() {
  const TITLE = "Contribution Cycle Details - BSG ContributionAdmin";
  const [searchText, setSearchText] = useState("");
  const [contributionData, setContributionData] = useState({});
  const [individualCycleData, setIndividualCycleData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedCycleId, setSelectedCycleId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [edit, setEdit] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [isContributionActive, setContributionActive] = useState(false);
  const [isDefault, setIsDefault] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [isAnotherModalOpen, setIsAnotherModalOpen] = useState(false);
  const [editObject, setEditObject] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [contributionCycleName, setContributionCycleName] = useState("");
  const [selectedReceiptType, setSelectedReceiptType] = useState("");
  const handleEdit = (event) => {
    setEdit(event.target.value);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const closeAnotherModal = () => {
    setIsAnotherModalOpen(false);
  };
  const handleTotalElements = async () => {
    const url = `${SERVICES.CONTRIBUTION_CYCLE}`;
    const response = await get(url);
    if (response.ok) {
      const data = await response.json();
      setTotalElements(data.data.totalElements);
    }
  };
  const handleEditCycle = async (cycleId) => {
    setSelectedCycleId(cycleId);
    setIsModalOpen(true);
    try {
      const url = `${SERVICES.CONTRIBUTION_CYCLE}/${cycleId}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setEditObject(data?.data);
        setEdit(data?.data?.name);
        setDateFrom(dayjs(data?.data?.startDate));
        setDateTo(dayjs(data?.data?.endDate));
        setContributionActive(data?.data?.status !== "NOT_ACTIVE");
        setIsDefault(data?.data?.defaultCycle);
        const idFromReceiptTypeList = data?.data?.receiptTypeList?.[0]?.id;
        setSelectedReceiptType(idFromReceiptTypeList);
      } else {
        console.error("Failed to fetch cycle data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleAnotherEditCycle = async (cycleId) => {
    setSelectedCycleId(cycleId);
    setIsAnotherModalOpen(true);
    try {
      const url = `${SERVICES.CONTRIBUTION_CYCLE}/${cycleId}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setEdit(data.data.name);
      } else {
        console.error("Failed to fetch cycle data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  // const handleDeleteCity = async (cityId)=>{
  //   try {
  //     const url = `${SERVICES.PAYABLE_CITY}/${cityId}`;
  //     const response = await del(url);
  //     if (response.ok) {
  //       await fetchPayableCityData();
  //     } else {
  //       console.error('Failed to update city data');
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //   }
  // }

  const fetchContributionData = useCallback(async () => {
    const url = `${SERVICES.CONTRIBUTION_CYCLE}?size=${DEFAULT_PAGE_SIZE}`;
    await fetchData(url, setContributionData, setIsLoading);
  }, []);

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };
  const handleDateChange = (name, date) => {
    // console.log("Received Date:", date);
    if (name === "dateFrom") {
      setDateFrom(date);
    } else if (name === "dateTo") {
      setDateTo(date);
    }
  };

  // const handleSearch = async () => {
  //   console.log(searchText);
  //   if (searchText.trim() === "") {
  //     return;
  //   }

  //   // const foundCycle = contributionData.content.find(
  //   //   (el) => el.name === searchText.trim(),
  //   // );
  //   const foundCycle = contributionData.content.find((el) =>
  //     el.name.toLowerCase().includes(searchText.trim().toLowerCase()),
  //   );
  //   if (foundCycle) {
  //     // setSelectedCityId(foundCity.id);

  //     try {
  //       const url = `${SERVICES.CONTRIBUTION_CYCLE}/${foundCycle.id}`;
  //       const response = await get(url);

  //       if (response && response.ok) {
  //         const data = await response.json();
  //         const cycleDataArray = [data.data];
  //         setIndividualCycleData(cycleDataArray);
  //       } else {
  //         console.error("Failed to fetch city data");
  //       }
  //     } catch (error) {
  //       console.error("Error:", error);
  //     }
  //   } else {
  //     setSelectedCycleId(null);
  //     toast.show("Contribution Cycle not Found", AlertStatus.ERROR);
  //   }
  // };
  const handleSearch = async () => {
    // console.log(searchText.trim());
    if (searchText.trim() === "") {
      fetchContributionData();
      return;
    }
    try {
      const url = `${SERVICES.CONTRIBUTION_CYCLE}?size=${totalElements}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const filteredData = data.data.content.filter((item) =>
          item.name.toLowerCase().includes(searchText.toLowerCase()),
        );
        if (filteredData.length === 0) {
          toast.show("Contribution Cycle Not Found", AlertStatus.ERROR);
        } else {
          setContributionData({ content: filteredData });
        }
      } else {
        console.error("Failed to fetch receipt data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  //   try{
  //     const url = `http://43.205.5.55:8081/contribution/api/payableCities/search?keyword=${searchText}`
  //     const response = await get(url);
  //     if(response.ok){
  //       const data = await response.json();
  //       if(data.data.content.length === 0){
  //         alert("City not found");
  //       }
  //       else{
  //         setPayableCityData(data.data);
  //       }
  //     }else {
  //          console.error('Failed to fetch city data');
  //           }
  //   } catch(error){
  //     console.error('Error', error);
  //   }
  // };

  const handleSubmit = async () => {
    // console.log(searchText);
    if (contributionCycleName.trim() === "") {
      return;
    }
    const url = SERVICES.CONTRIBUTION_CYCLE;
    const data = {
      name: contributionCycleName.trim(),
    };

    try {
      const response = await post(url, data);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        await fetchContributionData();
        toast.show(
          "Contribution Cycle Added Successfully",
          AlertStatus.SUCCESS,
        );
        setContributionCycleName("");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DD");
  }
  const handleContributionToggle = (isActive) => {
    setContributionActive(isActive);
  };
  const handleDefaultChange = (isDefault) => {
    setIsDefault(isDefault);
  };
  const handleSelectedReceipt = (receiptValue) => {
    setSelectedReceiptType(receiptValue);
  };

  const handleAnotherEditSubmit = async () => {
    if (edit.trim() === "") {
      toast.show("Contribution Cycle cannot be null", AlertStatus.ERROR);
      return;
    }
    try {
      const url = `${SERVICES.CONTRIBUTION_CYCLE}/${selectedCycleId}`;
      const data = {
        name: edit.trim(),
        startDate: null,
        endDate: null,
        defaultCycle: false,
        activate: false,
        receiptTypeList: [],
      };

      const response = await put(url, data);

      if (response.ok) {
        await fetchContributionData();
        toast.show(
          "Contribution Cycle Updated Successfully ",
          AlertStatus.SUCCESS,
        );
        // closeModal();
        closeAnotherModal();
      } else {
        console.error("Failed to update city data");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  // const handleEditSubmit = async () => {
  //   if (dateFrom && dateTo) {
  //     const actualDateFrom = dateFrom.$d;
  //     const actualDateTo = dateTo.$d;
  //     const formattedDateFrom = formatDateToYYYYMMDD(actualDateFrom);
  //     const formattedDateTo = formatDateToYYYYMMDD(actualDateTo);
  //     if (edit.trim() === "") {
  //       return;
  //     }
  //     try {
  //       const url = `${SERVICES.CONTRIBUTION_CYCLE}/${selectedCycleId}`;
  //       const data = {
  //         name: edit.trim(),
  //         startDate: formattedDateFrom,
  //         endDate: formattedDateTo,
  //         defaultCycle: isDefault,
  //         activate: isContributionActive,
  //       };

  //       const response = await put(url, data);

  //       if (response.ok) {
  //         await fetchContributionData();
  //         toast.show(
  //           "Contribution Cycle Updated Successfully ",
  //           AlertStatus.SUCCESS
  //         );
  //         closeModal();
  //       } else {
  //         console.error("Failed to update city data");
  //       }
  //     } catch (error) {
  //       toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
  //     }
  //   }
  //   // try {
  //   //   const url = `${SERVICES.CONTRIBUTION_CYCLE}/${selectedCycleId}`;
  //   //   const data = {
  //   //     // cityName: edit.trim(),
  //   //     startDate:dateFrom,
  //   //     endDate: dateTo,
  //   //   };

  //   //   const response = await put(url, data);

  //   //   if (response.ok) {
  //   //     await fetchContributionData();
  //   //     closeModal();
  //   //   } else {
  //   //     console.error("Failed to update city data");
  //   //   }
  //   // } catch (error) {
  //   //   console.error("Error:", error);
  //   // }
  // };
  const handleEditSubmit = async () => {
    if (!dateFrom || !dateTo) {
      // Date fields are empty
      toast.show("Please select both start and end dates", AlertStatus.ERROR);
      return;
    }

    const actualDateFrom = dateFrom.$d;
    const actualDateTo = dateTo.$d;

    if (actualDateFrom >= actualDateTo) {
      // Invalid date range
      toast.show(
        "Invalid date range. End date must be greater than start date",
        AlertStatus.ERROR,
      );
      return;
    }
    if (selectedReceiptType === "") {
      toast.show("Please Select Donation Purpose  ", AlertStatus.ERROR);
      return;
    }

    // if (!isContributionActive) {
    //   // Contribution is not active
    //   toast.show("Please activate the contribution cycle", AlertStatus.ERROR);
    //   return;
    // }

    if (edit.trim() === "") {
      // Contribution cycle name is empty
      toast.show("Contribution Cycle name cannot be empty", AlertStatus.ERROR);
      return;
    }

    try {
      const url = `${SERVICES.CONTRIBUTION_CYCLE}/${selectedCycleId}`;
      const formattedDateFrom = formatDateToYYYYMMDD(actualDateFrom);
      const formattedDateTo = formatDateToYYYYMMDD(actualDateTo);

      const data = {
        name: null,
        startDate: formattedDateFrom,
        endDate: formattedDateTo,
        defaultCycle: isDefault,
        activate: isContributionActive,
        receiptTypeList: [selectedReceiptType],
      };

      const response = await put(url, data);

      if (response.ok) {
        await fetchContributionData();
        toast.show(
          "Contribution Cycle Updated Successfully",
          AlertStatus.SUCCESS,
        );
        closeModal();
      } else {
        console.error("Failed to update city data");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };
  const getDefaultReceipt = async () => {
    try {
      const url = `${SERVICES.CONTRIBUTION_CYCLE}?size=200`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log("line 268", data?.data?.content[0]?.receiptTypeList[0]?.id);
        // setDefaultReceitData(data.data.content);
        const activeItem = data?.data?.content.find(
          (item) => item.status === "ACTIVE",
        );
        if (activeItem) {
          const { receiptTypeList } = activeItem;
          if (receiptTypeList.length > 0) {
            const idFromReceiptTypeList = receiptTypeList[0]?.id;
            setSelectedReceiptType(idFromReceiptTypeList);
          }
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    try {
      const url = `${SERVICES.CONTRIBUTION_CYCLE}?page=${selectedPage}&size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setContributionData(data.data);
      } else {
        console.error("Failed to fetch contribution data");
      }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContributionData();
  }, [fetchContributionData]);

  useEffect(() => {
    if (contributionData.content) {
      const updatedTableData = contributionData.content.map((item, index) => {
        const serialNumber = currentPage * DEFAULT_PAGE_SIZE + index + 1;
        return {
          id: item.id,
          column1: serialNumber,
          column2: item.name,
          column3: item.defaultCycle === true ? "Y" : "N",
          // column4: (
          //   <div style={{ display: "flex", justifyContent: "center" }}>
          //     <Button onClick={() => handleEditCycle(item.id)}>Activate</Button>
          //   </div>
          // ),
          column4: (
            <div
              style={{
                display: "flex",
                gap: "25px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <EditIcon
                onClick={() => handleAnotherEditCycle(item.id)}
                style={{ cursor: "pointer" }}
              />
              <CheckOutlinedIcon
                sx={{ cursor: "pointer" }}
                onClick={() => handleEditCycle(item.id)}
              />
              {/* <Button onClick={() => handleEditCycle(item.id)}>Activate</Button> */}
            </div>
          ),
        };
      });
      setTableData(updatedTableData);
      setSearchText("");
    }
  }, [contributionData.content]);
  useEffect(() => {
    handleTotalElements();
  }, []);
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  // useEffect(() => {
  //   if (individualCycleData.length > 0) {
  //     const updatedTableData = individualCycleData.map((item, index) => {
  //       return {
  //         id: item.id,
  //         column1: index + 1,
  //         column2: item.name,
  //         column3: item.defaultCycle === true ? "Y" : "N",
  //         // column4: (
  //         //   <>
  //         //     {/* <Btn onClick={() => handleEditCycle(item.id)}>Edit</Btn> */}
  //         //     <Button onClick={() => handleEditCycle(item.id)}>Activate</Button>
  //         //     {/* <Btn  onClick={() => handleDeleteCity(item.id)}>
  //         //     Delete
  //         //   </Btn> */}
  //         //   </>
  //         // ),
  //         column4: (
  //           <div
  //             style={{
  //               display: "flex",
  //               gap: "25px",
  //               justifyContent: "center",
  //               alignItems: "center",
  //             }}
  //           >
  //             <EditIcon
  //               onClick={() => handleAnotherEditCycle(item.id)}
  //               style={{ cursor: "pointer" }}
  //             />
  //             <CheckOutlinedIcon
  //               sx={{ cursor: "pointer" }}
  //               onClick={() => handleEditCycle(item.id)}
  //             />
  //             {/* <Button onClick={() => handleEditCycle(item.id)}>Activate</Button> */}
  //           </div>
  //         ),
  //       };
  //     });

  //     setTableData(updatedTableData);
  //     setSearchText("");
  //   }
  // }, [individualCycleData]);

  // console.log(dateFrom);
  // console.log(dateTo);
  useEffect(() => {
    getDefaultReceipt();
  }, []);
  // console.log("line 574", selectedReceiptType);
  const tableHeaders = ["S. No.", "Contribution Cycle", "Default", "Action"];
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Contribution Cycle Details" />
      <OuterContainerStyles>
        <Title>Contribution Cycle Details</Title>
        <SearchContainer>
          <InputField
            onChange={(e) => setContributionCycleName(e.target.value)}
            placeholder="Add Cycle"
            customvalue={contributionCycleName}
          />
          <Button
            onClick={handleSubmit}
            disabled={!contributionCycleName?.trim()} // 🔹 Disable when empty
          >
            + Add
          </Button>
        </SearchContainer>
      </OuterContainerStyles>
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <ExistingText>Existing Contribution Cycle (s)</ExistingText>
        <SearchContainerTable>
          <div style={{ width: "50%" }}>
            <InputField
              onChange={handleInputChange}
              placeholder="Search here..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              value={searchText}
            />
          </div>
          <Button onClick={handleSearch}>Search</Button>
          <Btn type="button" onClick={fetchContributionData}>
            View All
          </Btn>
        </SearchContainerTable>
        {tableData?.length ? (
          <TableData
            tableData={tableData}
            data={contributionData}
            headers={tableHeaders}
            onPageChange={handlePageChange}
          />
        ) : (
          !tableData?.length && isLoading === false && <NoData />
        )}
      </OuterContainerStyles>
      {/* <EditModal isOpen={isModalOpen} handleClose={closeModal}  onChange={handleEdit} handleSubmit={handleEditSubmit} heading={'Edit City'} placeholder={'Enter City Name ...'}/>  */}
      <CycleModal
        isOpen={isModalOpen}
        handleClose={closeModal}
        onChange={handleEdit}
        handleSubmit={handleEditSubmit}
        heading="Activate Contribution Rights"
        contName={edit}
        dateFrom={dateFrom}
        dateTo={dateTo}
        onDateChange={handleDateChange}
        isContributionActive={isContributionActive}
        onContributionToggle={handleContributionToggle}
        isDefault={isDefault}
        onDefaultChange={handleDefaultChange}
        editObject={editObject}
        onSelectReceipt={handleSelectedReceipt}
        selectedReceiptType={selectedReceiptType}
      />
      <EditModal
        isOpen={isAnotherModalOpen}
        handleClose={closeAnotherModal}
        onChange={handleEdit}
        handleSubmit={handleAnotherEditSubmit}
        heading="Edit Cycle"
        placeholder="Enter Cycle Name ..."
        initialValue={edit}
      />
      {isLoading && <Loader />}
    </div>
  );
}

export default ContributionCycleDetails;

const Btn = styled.button`
  border: none;
  background-color: transparent;
  color: #00adf8;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
`;
